import { Element, useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";

import PrimitivesFloatingOptions from "@/components/editor/block-outline/floating-options/primitives-floating-component";
import Action, {
  ActionComponentStyle,
  ACTIONS,
} from "@/components/editor/primitives/legacy/action/action-component";
import RichText from "@/components/editor/primitives/rich-text";
import Text from "@/components/editor/primitives/text/text-component";
import useRichTextCompatible from "@/hooks/use-rich-text-compatible";

import { CTAButtonWrapper, Wrapper } from "./paragraph-item-component-styles";

export type ParagraphItemProps = {
  subTitle: string;
  description: string;
  showCTA?: boolean;
};

export default function ParagraphItem(props: ParagraphItemProps) {
  const {
    id,
    connectors: { connect },
  } = useNode();

  const isRichTextCompatible = useRichTextCompatible(id, [
    "paragraph-item-sub-title",
    "paragraph-item-description",
  ]);

  const ctaButtonStyle = React.useMemo<ActionComponentStyle>(
    () => ({
      padding: [rem(12), `${rem(12)} ${rem(52)}`, `${rem(12)} ${rem(52)}`],
    }),
    []
  );

  return (
    <Wrapper ref={connect} data-testid="paragraph-item">
      {isRichTextCompatible ? (
        <>
          <Element
            id="paragraph-item-sub-title"
            is={RichText}
            text={props.subTitle}
          />
          <Element
            id="paragraph-item-description"
            is={RichText}
            text={props.description}
          />
        </>
      ) : (
        <>
          <Element
            id="paragraph-item-sub-title"
            is={Text}
            text={props.subTitle}
            pattern="headingThree"
            element="h3"
          />
          <Element
            id="paragraph-item-description"
            is={Text}
            text={props.description}
            pattern="paragraph"
          />
        </>
      )}
      {props.showCTA && (
        <CTAButtonWrapper>
          <Element
            id="cta-button"
            is={Action}
            element="button"
            text="Register"
            style={ctaButtonStyle}
            action={ACTIONS.registrationPage}
            actions={[ACTIONS.registrationPage, ACTIONS.externalLink]}
            showOptions
          />
        </CTAButtonWrapper>
      )}
    </Wrapper>
  );
}

ParagraphItem.craft = {
  custom: {
    displayName: "Paragraph Item",
  },
  related: {
    leftOutlineOptions: PrimitivesFloatingOptions,
  },
};
